import { render, staticRenderFns } from "./settingCompanyStatutoryInformation.vue?vue&type=template&id=5c4023c8&scoped=true&"
import script from "./settingCompanyStatutoryInformation.vue?vue&type=script&lang=js&"
export * from "./settingCompanyStatutoryInformation.vue?vue&type=script&lang=js&"
import style0 from "./settingCompanyStatutoryInformation.vue?vue&type=style&index=0&id=5c4023c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4023c8",
  null
  
)

export default component.exports